<template>
  <div class="input-group" :class="{'has-validation': errorMessage}" v-if="valueModel">
    <div class="form-floating" :class="{'is-invalid': errorMessage}">
      <input
        ref="inputNumber"
        type="number"
        :id="'inputNumber-' + $.uid"
        class="form-control"
        :class="[errorMessage ? 'is-invalid' : '', props.inputClass]"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
        :value="valueModel.value"
        @input="(payload) => inputUpdate(payload)"
        :required="props.required"
        inputmode="numeric"
        :min="props.min"
        :max="props.max"
      />
      <label :for="'inputNumber-' + $.uid">
        {{props.label}} <span v-if="props.subLabel" class="fst-italic">({{ props.subLabel }})</span> {{ props.required ? '*' : '' }}
      </label>
      <div v-if="props.type !== 'euro' && !props.groupText" class="invalid-feedback">{{ errorMessage }}</div>
    </div>
    <span v-if="props.type === 'euro'" class="input-group-text"><small v-html="props.groupText ? `€ ${props.groupText}` : '€'"></small></span>
    <span v-else-if="props.groupText" class="input-group-text"><small v-html="props.groupText"></small></span>
    <div v-if="(props.type === 'euro' || props.groupText) && errorMessage" class="invalid-feedback">{{ errorMessage }}</div>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed, useTemplateRef } from 'vue';

const model = defineModel<number|null>({required: false});
const input = useTemplateRef('inputNumber');

defineExpose({focus: () => {
  if(input.value) {
    input.value.focus();
  }
}})

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  valueAsString?: boolean;
  label: string;
  subLabel?: string;
  placeholder?: string;
  required?: boolean;
  type?: 'number' | 'euro';
  groupText?: string;
  min?: number;
  max?: number;
  inputClass?: string;
  disabled?: boolean;
}>(), {
  valueAsString: false,
  placeholder: '',
  required: false,
  type: 'number',
  inputClass: '',
  disabled: false
});

const { value, errorMessage } = props.valueKey !== undefined ? useField<number | string>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})

const inputUpdate = (payload: Event) => {
  if(!valueModel.value) return;

  let resultNumber = parseFloat((payload.target as HTMLInputElement)?.value);
  if(isNaN(resultNumber)) {
    valueModel.value.value = null
    return
  }
  if(props.max) {
    resultNumber = Math.min(resultNumber, props.max);
  }
  if(props.min) {
    resultNumber = Math.max(resultNumber, props.min);
  }

  if(props.valueAsString) {
    valueModel.value.value = resultNumber.toString();
  } else {
    valueModel.value.value = resultNumber;
  }
}

</script>
